"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useOnClickOutside_1 = require("../../../../hooks/useOnClickOutside");
var table_1 = require("../../../../types/table");
var SvgSpriteLoader_1 = __importDefault(require("../../SvgSpriteLoader"));
var TableHeaderAction = function (_a) {
    var actionIcon = _a.actionIcon, ActionComponent = _a.ActionComponent, actionComponentProps = _a.actionComponentProps, actionAlign = _a.actionAlign, actionAlignClassName = _a.actionAlignClassName, headerAlign = _a.headerAlign, id = _a.id, columnKey = _a.columnKey;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var ref = react_1.useRef(null);
    var handleVisibility = function () { return setIsOpen(!isOpen); };
    var handleClose = function () { return setIsOpen(false); };
    var onClickAction = function (data) {
        var _a;
        (_a = actionComponentProps === null || actionComponentProps === void 0 ? void 0 : actionComponentProps.onClick) === null || _a === void 0 ? void 0 : _a.call(actionComponentProps, data);
    };
    useOnClickOutside_1.useOnClickOutside(ref, function () { return handleClose(); });
    return (react_1.default.createElement("div", { ref: ref, className: headerAlign === table_1.DataAlign.LEFT && actionAlign === table_1.DataAlign.RIGHT ? 'tw-relative' : '', "data-testid": "table-header-row-cell-action-wrapper-" + columnKey + "-" + id },
        react_1.default.createElement(SvgSpriteLoader_1.default, __assign({ className: 'tw-cursor-pointer tw-ml-1.5', onClick: handleVisibility }, actionIcon)),
        react_1.default.createElement("div", { "data-testid": "table-header-row-cell-action-" + columnKey + "-" + id, className: "tw-absolute " + (actionAlign === table_1.DataAlign.RIGHT ? (headerAlign === table_1.DataAlign.LEFT ? 'tw-right-0' : 'tw-right-6') : 'tw-left-6') + " " + (isOpen ? 'tw-opacity-100' : 'tw-opacity-0') + " " + actionAlignClassName },
            react_1.default.createElement(ActionComponent, __assign({}, actionComponentProps, { onClick: onClickAction, onClose: handleClose, isOpen: isOpen })))));
};
exports.default = TableHeaderAction;
